import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    checkVersion,
    outdatedVersion,
} from '../../store/WriteClass';

class VersionCheck extends Component {

    componentDidMount() {
        this.props.checkVersion();  // check initially
        if (this.props.enableInterval) {
            this.startPolling(); // start checking at 1 hour interval
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.app_version !== this.props.app_version && this.props.app_version !== undefined) {
            // if version changes then issue an OUTDATED_VERSION action
            this.props.outdatedVersion();
        }
    }

    componentWillUnmount() {
        if (this.props.enableInterval) {
            this.stopPolling();
        }
    }

    startPolling() {
        if (this.interval) {
            // remove interval timer if it is somehow hanging around
            this.stopPolling();
        }
        this.interval = setInterval(this.props.checkVersion, 1000*this.props.intervalInSeconds);
    }

    stopPolling() {
        clearInterval(this.interval);
    }

    render() {
        return null;
    }
}

VersionCheck.propTypes = {
    enableInterval: PropTypes.bool,  // optional
    intervalInSeconds: PropTypes.number, // optional
}

const mapStateToProps = (state) => ({
    app_version: state.write_class.app_version,
});

const mapDispatchToProps = (dispatch) => ({
    checkVersion: () => dispatch(checkVersion()),
    outdatedVersion: () => dispatch(outdatedVersion()),
});

export default connect(mapStateToProps, mapDispatchToProps)(VersionCheck);



// WEBPACK FOOTER //
// ./src/components/versionCheck/index.jsx